import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";
import reducers from "./reducers";
import { LicenseManager } from "ag-grid-enterprise";
import App from "./App";

import "./css/bootstrap.min.css";
import "./css/font-awesome.css";
import "./css/admissionform.css";

LicenseManager.setLicenseKey("sdfgsdfg4234452345kj2g5jh23kj4h5b245");

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  {},
  composeEnhancers(applyMiddleware(reduxThunk))
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector("#root")
);



// WEBPACK FOOTER //
// ./src/index.js